export const formatCardTitle = (cardTitle: string): string => {
    return cardTitle.replace(/(VIEW\s)(.)([^(]+)(|\s\([A-Z]+\))/gi, (_a, w, x, y, z) => {
        return `${x}${y.toLowerCase()}${z}`
    })
}
